module.exports = __webpack_public_path__ + "img/icons_7.5480bdaf.svg";